const parametrizationSettingsHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Perfil',
    columns: [
      {
        name: 'Nome',
        id: 'perfil-nome',
        show: true
      }
    ]
  },
  {
    group: 'Parametros',
    columns: [
      {
        name: 'Abastecer',
        id: 'param-1',
        show: true
      },
      {
        name: 'Tipo de Suprimento',
        id: 'param-2',
        show: true
      },
      {
        name: 'Usar Politica de Estoque Otimizada',
        id: 'param-3',
        show: true
      },
      {
        name: 'Incluir Projeções de Venda',
        id: 'param-4',
        show: true
      },
      {
        name: 'Utilizar Estoque Minimo',
        id: 'param-5',
        show: true
      },
      {
        name: ' EMax',
        id: 'param-6',
        show: true
      },

      {
        name: 'Frequência de Pedidos',
        id: 'param-7',
        show: true
      },
      {
        name: 'Lead Time',
        id: 'param-8',
        show: true
      },
      {
        name: 'Lote Múltiplo',
        id: 'param-9',
        show: true
      },
      {
        name: 'Política de Estoque Arbitrária',
        id: 'param-10',
        show: true
      },
      {
        name: 'Lote Mínimo CD',
        id: 'param-11',
        show: true
      },
      {
        name: 'Estoque Arbitrado',
        id: 'param-12',
        show: true
      },
      {
        name: 'Estoque minimo',
        id: 'param-13',
        show: true
      },
      {
        name: 'Status',
        id: 'param-14',
        show: true
      },
      // {
      //   name: 'Cluster Centro',
      //   id: 'param-15',
      //   show: true
      // },
      // {
      //   name: 'Cluster Produto',
      //   id: 'param-16',
      //   show: true
      // }
      // },
      // {
      //   name: 'Status',
      //   id: 'param-15',
      //   show: true
      // },
      {
        name: 'Ponto de Pedido',
        id: 'param-18',
        show: true
      }
    ]
  }
]

export default parametrizationSettingsHeader
